import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { Form, message } from "antd";
import {  SDrawerOrModal, SGeneralForms } from "shj-components";
import { generalStandardCopy, getProductCommonPage } from "@/services/product.ts";
import DebounceSearchSelect from '@/pages/baseProduct/components/DebounceSearchSelect'
import { httpOrgList } from "@/services/homeService.ts";

const CopyModal = (props) => {
  const { open, onClose, record = {}, onReload } = props;
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [productId, setProductId] = useState('')
  const startDate = Form.useWatch('startDate', form);

  useEffect(() => {
    if (open) {
      form.resetFields()
      form.setFieldsValue({applyProdIds: ['0'], orgIds: ['0']});
    }
  }, [open]);

  const getOptions = () => {
    setLoading(true)
    return Promise.all([
      httpOrgList({status: undefined}),
    ]).then(res => {
      return {companyList: [{name: '通用', id: '0'}, ...res[0]]}
    }).finally(() => {
      setLoading(false)
    })
  }

  const onSelectProduct = ({ value }) => {
    console.log(record)
    if(!record.id) {
      const productIds = form.getFieldValue('applyProdIds')
      if(value === '0'){
        form.setFieldsValue({applyProdIds: ['0']})
      } else {
        form.setFieldsValue({applyProdIds: productIds.filter(productId => productId !== '0')})
      }
    } else {
      setProductId(value)
      form.setFieldValue('applyProdIds', value)
    }
  }

  const onFinish = () => {
    form.validateFields().then(values => {
      setLoading(true)
      generalStandardCopy({
        ...values,
        ...props.query,
        startDate: values.startDate && dayjs(values.startDate).format('YYYY-MM-DD'),
        endDate: values.endDate && dayjs(values.endDate).format('YYYY-MM-DD'),
      }).then(res => {
        message.success(res.message || '操作成功')
        onClose?.()
        onReload?.()
      }).finally(() => setLoading(false))
    })
  }

  return <>
    <SDrawerOrModal
      title={'复制'}
      mode={'modal'}
      width={500}
      open={open}
      loading={loading}
      onCancel={() => {
        onClose();
      }}
      onOk={onFinish}
    >
      <SGeneralForms
        layout={'vertical'}
        formConfig={{ form }}
        httpOptionsFn={getOptions}
        configs={[{
          formItem: [
            {
              spanCol: 24,
              label: '适用产品',
              name: 'applyProdIds',
              required: true,
              rules: [{ required: true, message: '适用产品不能为空' }],
              type: 'select',
              children: (
                <DebounceSearchSelect
                  allowClear
                  label={'适用产品'}
                  isCommon={true}
                  mode={"multiple"}
                  fixedParams={{ prodTypes: ['PRODUCT_PACKAGE'] }}
                  fetchOptions={getProductCommonPage}
                  fieldNames={{ label: 'prodName', value: 'id' }}
                  onSelect={onSelectProduct}
                  query={(record.id && productId) ? {id: productId} : {}}
                />
              ),
            },
            {
              spanCol: 24,
              label: '适用门店',
              name: 'orgIds',
              required: true,
              rules: [{ required: true, message: '适用门店不能为空' }],
              type: 'select',
              data: 'companyList',
              comConfig: {
                mode: "multiple",
                fieldNames: {label: 'name', value: 'id'},
                onSelect: (v) => {
                  const orgIds = form.getFieldValue('orgIds')
                  if(v === '0'){
                    form.setFieldsValue({orgIds: ['0']})
                  } else {
                    form.setFieldsValue({orgIds: orgIds.filter(shop => shop !== '0')})
                  }
                }
              }
            },
            {
              spanCol: 24,
              label: '开始日期',
              name: 'startDate',
              required: true,
              rules: [{ required: true, message: '开始日期不能为空' }],
              type: 'date',
            },
            {
              spanCol: 24,
              label: '结束日期',
              name: 'endDate',
              type: 'date',
              rules: [{
                validator: (_, endDate) => {
                  const start = new Date(startDate);
                  const end = new Date(endDate);
                  if (end <= start) {
                    return Promise.reject('结束日期需大于开始日期')
                  }
                  return Promise.resolve()
                }
              }],
            },
          ]
        }]}
      />
    </SDrawerOrModal>
  </>
}

export default CopyModal